import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, FontIcon } from '@gik/ui';
import SavedArticlesList from './SavedArticlesList';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';

const blockName = 'saved-articles-section';

export interface ISavedArticlesSection {}

export default function SavedArticlesSection() {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <section className={bem()}>
      <div className={bem('title')}>{t(translationKeys.title)}</div>
      <SavedArticlesList />
      <Button
        className={bem('button')}
        type="a"
        externalLink
        href="/articles"
        variant="primary"
        prepend={<FontIcon name="article" />}
      >
        {t(translationKeys.btnSeeAll)}
      </Button>
    </section>
  );
}
